export default __webpack_public_path__ + "static/youtube-icon-062a2857e1f5104bf296aac5e6352c4b.png";